/**
 * Validation utilities
 */

export const validateEmail = (email: string): string | null => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    return 'Please enter a valid email address';
  }
  return null;
};

export const validatePassword = (password: string): string | null => {
  if (password.length === 0) {
    return 'Password is required';
  }
  return null;
};

export const validateRequired = (value: string): boolean => {
  return value.trim().length > 0;
};
